import React from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import GallerySection from './GallerySection';
import styles from './GalleryPage.module.css';

const GalleryPage = () => {
  return (
      <GallerySection />
  );
};

export default GalleryPage;